
/*
 * The Crochet Flower Company
 * Cart delivery scheduler — checkout validation and saving
 */

(function () {
  if (window.CrochetDeliveryCheckoutInstalled) return;
  window.CrochetDeliveryCheckoutInstalled = true;

  let checkoutInProgress = false;


  /*
   * Delivery zone classification
   * Best-fit postcode assignments.
   * Zone D is the nationwide fallback.
   */

  const ZONE_A_POSTCODES = new Set([
    '10110', '10330', '10400', '10500', '10120'
  ]);

  const ZONE_B_POSTCODES = new Set([
    '10240', '10260', '10270',
    '10900', '11000', '11130'
  ]);

  const ZONE_E_POSTCODES = new Set([
    '84140', '84280', '84310', '84320',
    '84360', '81150', '82160', '23170'
  ]);

  function getDeliveryZone(postcode) {
    const code = String(postcode).trim();

    if (!/^\d{5}$/.test(code)) return null;

    if (code === '11120') return 'C';
    if (ZONE_A_POSTCODES.has(code)) return 'A';
    if (ZONE_B_POSTCODES.has(code)) return 'B';
    if (ZONE_E_POSTCODES.has(code)) return 'E';

    return 'D';
  }



  // Initialize the scheduler, including after AJAX cart updates.
  function initScheduler(root) {
    if (root.dataset.initialized === 'true') return;

    const postal = root.querySelector('.delivery-postal');
    const options = root.querySelector('.delivery-options');
    const method = root.querySelector('.delivery-method');
    const methodValue = root.querySelector('.delivery-method-value');
    const date = root.querySelector('.delivery-date');
    const dateLabel = root.querySelector('.delivery-date-label');
    const timeContainer = root.querySelector('.delivery-time-container');
    const time = root.querySelector('.delivery-time');
    const notice = root.querySelector('.delivery-notice');

    if (!postal || !options || !method || !methodValue ||
        !date || !dateLabel || !timeContainer || !time || !notice) {
      return;
    }

    root.dataset.initialized = 'true';

    
  // Current date and time in Bangkok (UTC+7).
  function getBangkokNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Bangkok',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());

    const get = type =>
      Number(parts.find(part => part.type === type).value);

    return {
      year: get('year'),
      month: get('month'),
      day: get('day'),
      minutes: get('hour') * 60 + get('minute')
    };
  }

  // Add calendar days, optionally skipping Sundays.
  function addDeliveryDays(daysAhead, skipSundays = false) {
    const now = getBangkokNow();

    const result = new Date(Date.UTC(
      now.year,
      now.month - 1,
      now.day + daysAhead
    ));

    if (skipSundays) {
      while (result.getUTCDay() === 0) {
        result.setUTCDate(result.getUTCDate() + 1);
      }
    }

    return result.toISOString().slice(0, 10);
  }

  // Earliest selectable date for each zone.
  function getMinimumDeliveryDate(zone) {
    const now = getBangkokNow();
    const minutes = now.minutes;

    switch (zone) {
      case 'A':
      case 'B':
        return addDeliveryDays(1, true);

      case 'C':
        return addDeliveryDays(2, true);

      case 'D':
        return addDeliveryDays(
          minutes < 12 * 60 + 30 ? 2 : 3
        );

      case 'E':
        return addDeliveryDays(
          minutes < 10 * 60 ? 3 : 4
        );

      default:
        return addDeliveryDays(3);
    }
  }


function updateDeliveryCalendar() {
  const code = postal.value.replace(/\D/g, '').slice(0, 5);

  if (code.length !== 5) return;
  if (typeof flatpickr !== 'function') return;

  const zone = getDeliveryZone(code);
  const isLocal = ['A', 'B', 'C'].includes(zone);
  const minimumDate = getMinimumDeliveryDate(zone);

  // Create the calendar once, then update its rules.
  if (!date._flatpickr) {
    flatpickr(date, {
      dateFormat: 'Y-m-d',
      minDate: minimumDate,
      disableMobile: true,
      allowInput: false,
      showMonths: 1,
      monthSelectorType: 'static',
      disable: isLocal
        ? [function (selectedDate) {
            return selectedDate.getDay() === 0;
          }]
        : [],
      onChange: function () {
        date.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });
  } else {
    date._flatpickr.set('minDate', minimumDate);
    date._flatpickr.set(
      'disable',
      isLocal
        ? [function (selectedDate) {
            return selectedDate.getDay() === 0;
          }]
        : []
    );
  }
}

  
  function getAvailableTimeWindows(zone, selectedDate) {
    const allWindows = [
      '9:00 AM - 12:00 PM',
      '12:00 PM - 3:00 PM',
      '3:00 PM - 6:00 PM'
    ];

    // EMS destinations do not have time windows.
    if (!['A', 'B', 'C'].includes(zone)) {
      return [];
    }

    // Zone C: all windows on eligible dates.
    if (zone === 'C') {
      return allWindows;
    }

    // All windows available for dates other than tomorrow.
    const tomorrow = addDeliveryDays(1, false);

    if (selectedDate !== tomorrow) {
      return allWindows;
    }

    const minutes = getBangkokNow().minutes;

    if (zone === 'A') {
      if (minutes >= 16 * 60 + 30) {
        return [allWindows[2]];
      }

      if (minutes >= 14 * 60 + 30) {
        return [allWindows[1], allWindows[2]];
      }

      return allWindows;
    }

    if (zone === 'B') {
      if (minutes >= 15 * 60 + 30) {
        return [allWindows[2]];
      }

      if (minutes >= 13 * 60 + 30) {
        return [allWindows[1], allWindows[2]];
      }

      return allWindows;
    }

    return allWindows;
  }
 


  function updateTimeWindowOptions(scheduler) {
    const postal = scheduler.querySelector('.delivery-postal');
    const date = scheduler.querySelector('.delivery-date');
    const time = scheduler.querySelector('.delivery-time');

    if (!postal || !date || !time) return;

    const zone = getDeliveryZone(postal.value.trim());
    const allowedWindows = getAvailableTimeWindows(
      zone,
      date.value
    );

    const previousValue = time.value;

    Array.from(time.options).forEach(option => {
      if (!option.value) return;

      const available = allowedWindows.includes(option.value);

      option.disabled = !available;
      option.hidden = !available;
    });

    // Clear a previously selected time if it is no longer available.
    if (previousValue && !allowedWindows.includes(previousValue)) {
      time.value = '';
    }
  }



    function updateDeliveryOptions(resetValues = false) {
      const code = postal.value.replace(/\D/g, '').slice(0, 5);
      postal.value = code;

      if (resetValues) {
        date.value = '';
        time.value = '';
      }

      options.hidden = code.length !== 5;

      if (code.length !== 5) {
        methodValue.value = '';
        return;
      }

      // Classify the destination using our five delivery zones.
      const zone = getDeliveryZone(code);
      const isLocal = ['A', 'B', 'C'].includes(zone);

      if (isLocal) {
        method.textContent =
          zone === 'C' ? 'Extended Local Delivery' : 'Bangkok Local Delivery';

        methodValue.value = method.textContent;
        dateLabel.textContent = 'Delivery Date';

        // Temporary minimum dates until we implement zone-specific cutoffs.
        date.min = getMinimumDeliveryDate(zone);

        timeContainer.hidden = false;
        notice.hidden = true;
      } else {
        method.textContent =
          zone === 'E' ? 'Extended Transit Delivery' : 'Standard Provincial Delivery';

        methodValue.value = 'Thailand Post EMS';
        dateLabel.textContent = 'Approximate Delivery Date';

        // Temporary minimum dates until we implement EMS cutoffs.
        date.min = getMinimumDeliveryDate(zone);

      timeContainer.hidden = true;
      notice.hidden = false;
      time.value = '';
      }

      // Discard saved dates that are no longer eligible.
      if (date.value && date.value < date.min) {
      date.value = '';
      }

      // Refresh available time windows after postcode changes.
      updateTimeWindowOptions(root);
      updateDeliveryCalendar();
    } 

    
    postal.addEventListener('input', function () {
      updateDeliveryOptions(true);
      clearError(root);
    });

  date.addEventListener('change', function () {
    const zone = getDeliveryZone(postal.value.trim());
    const isLocal = ['A', 'B', 'C'].includes(zone);

    if (date.value && isLocal) {
    const selectedDay = new Date(
      date.value + 'T12:00:00Z'
    ).getUTCDay();

    if (selectedDay === 0) {
      date.value = '';
      time.value = '';

      showError(
        root,
        'Sunday delivery is unavailable. Please select another date.'
      );

      updateTimeWindowOptions(root);
      return;
    }
  }

  updateTimeWindowOptions(root);
  clearError(root);
});

    time.addEventListener('change', function () {
      clearError(root);
    });

    updateDeliveryOptions(false);
  }

  function initializeAllSchedulers() {
    document.querySelectorAll('[data-delivery-scheduler]')
      .forEach(initScheduler);
  }

  // Initialize existing scheduler elements.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllSchedulers
    );
  } else {
    initializeAllSchedulers();
  }

  // Initialize schedulers inserted by Cornerstone's AJAX cart.
  const schedulerObserver = new MutationObserver(function () {
    initializeAllSchedulers();
  });

  schedulerObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });


  function showError(scheduler, message) {
    const error = scheduler.querySelector('.delivery-error');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }

    const details = scheduler.querySelector('details');
    if (details) details.open = true;

    scheduler.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  function clearError(scheduler) {
    const error = scheduler.querySelector('.delivery-error');
    if (error) error.hidden = true;
  }

  function validate(scheduler) {
    const postal = scheduler.querySelector('.delivery-postal');
    const date = scheduler.querySelector('.delivery-date');
    const time = scheduler.querySelector('.delivery-time');

    const code = postal.value.trim();

    if (!/^\d{5}$/.test(code)) {
      return 'Please enter a valid 5-digit Thai postal code.';
    }

    const zone = getDeliveryZone(code);
    const isLocal = ['A', 'B', 'C'].includes(zone);

    if (!date.value) {
      return isLocal
      ? 'Please select your delivery date.'
      : 'Please select your approximate delivery date.';
}

    
    // Recalculate the earliest date using current Bangkok time.
    const currentMinimumDate = getMinimumDeliveryDate(zone);

    // Update the calendar's minimum date.
    date.min = currentMinimumDate;

    // Reject dates that have become unavailable.
    if (!date.value || date.value < currentMinimumDate) {
    return 'This delivery date is no longer available. Please select another date.';
    }

    // Sundays are unavailable for local delivery only.
    const selectedDay = new Date(
      date.value + 'T12:00:00Z'
    ).getUTCDay();

    if (isLocal && selectedDay === 0) {
      return 'Sunday delivery is unavailable. Please select another date.';
    }

    if (isLocal && !time.value) {
    return 'Please select your delivery time window.';
    }

// Recalculate eligibility at checkout in case the cutoff has passed.
if (isLocal) {
  const allowedWindows = getAvailableTimeWindows(
    zone,
    date.value
  );

  if (!allowedWindows.includes(time.value)) {
    return 'This delivery time is no longer available. Please select another time window.';
  }
}

    return null;

  }

  
  async function saveDeliveryDetails(scheduler) {
    const postal = scheduler.querySelector('.delivery-postal').value.trim();
    const date = scheduler.querySelector('.delivery-date').value;
    const time = scheduler.querySelector('.delivery-time').value;

    const zone = getDeliveryZone(postal);
    const isLocal = ['A', 'B', 'C'].includes(zone);

    const methodNames = {
      A: 'Bangkok Local Delivery',
      B: 'Bangkok Local Delivery',
      C: 'Extended Local Delivery',
      D: 'Thailand Post EMS',
      E: 'Thailand Post EMS'
    };

    const attributes = {
      'Recipient Postal Code': postal,
      'Delivery Zone': zone,
      'Delivery Method': methodNames[zone],
      'Delivery Date': date,
      'Delivery Time': isLocal ? time : ''
    };

    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes })
      }
    );

    if (!response.ok) {
      throw new Error('Unable to save delivery details.');
    }

    const cart = await response.json();

    for (const [key, value] of Object.entries(attributes)) {
      if (cart.attributes?.[key] !== value) {
        throw new Error('Delivery details were not saved correctly.');
      }
    }
  }


  
  // Intercept checkout clicks before other cart scripts.
  document.addEventListener('click', async function (event) {
    const button = event.target.closest(
      '.quick-cart__submit[name="checkout"]'
    );

    if (!button) return;

    // Prevent Cornerstone or Bird from continuing checkout
    // before our delivery details are validated and saved.
    event.preventDefault();
    event.stopImmediatePropagation();

    if (checkoutInProgress) return;

    const form = button.closest('form');
    const scheduler = form?.querySelector('[data-delivery-scheduler]');

    if (!scheduler) {
      console.error('Delivery scheduler not found. Checkout blocked.');
      return;
    }

    clearError(scheduler);

    const validationError = validate(scheduler);

    if (validationError) {
      showError(scheduler, validationError);
      return;
    }

    checkoutInProgress = true;
    button.disabled = true;

    const originalText = button.textContent;
    button.textContent = 'Saving delivery details...';

    try {
      await saveDeliveryDetails(scheduler);

      // Shopify confirmed that the attributes were saved.
      window.location.assign(
        (window.Shopify?.routes?.root || '/') + 'checkout'
      );
    } catch (error) {
      console.error('Delivery scheduler:', error);

      showError(
        scheduler,
        'We could not save your delivery details. Please try again.'
      );

      button.disabled = false;
      button.textContent = originalText;
      checkoutInProgress = false;
    }
  }, true);
})();
